export default {"src":"/_next/static/media/earth-globe-modern.102e51f7.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};